//# sourceMappingURL=input.mjs.map
/// <reference types="./input.d.mts" />
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $length from "../../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../../sketch/sketch/css/length.mjs";
import * as $sh from "../../../../sketch_redraw/sketch/redraw/dom/hooks/html.mjs";
import * as $bool_ from "../../../../tiamat/gleam/bool_.mjs";
import * as $colors from "../../../ds/colors.mjs";
import * as $icons from "../../../ds/icons.mjs";
import * as $position from "../../../ds/position.mjs";
import * as $text from "../../../ds/typography/text.mjs";
import { toList, CustomType as $CustomType } from "../../../gleam.mjs";

export class Xs extends $CustomType {}
export const Size$Xs = () => new Xs();
export const Size$isXs = (value) => value instanceof Xs;

export class Small extends $CustomType {}
export const Size$Small = () => new Small();
export const Size$isSmall = (value) => value instanceof Small;

export class Medium extends $CustomType {}
export const Size$Medium = () => new Medium();
export const Size$isMedium = (value) => value instanceof Medium;

export class Standard extends $CustomType {}
export const State$Standard = () => new Standard();
export const State$isStandard = (value) => value instanceof Standard;

export class Error extends $CustomType {}
export const State$Error = () => new Error();
export const State$isError = (value) => value instanceof Error;

export class Disabled extends $CustomType {}
export const State$Disabled = () => new Disabled();
export const State$isDisabled = (value) => value instanceof Disabled;

export function wrapper(attrs, children) {
  return $sh.label(
    attrs,
    children,
    () => {
      return $css.class$(
        toList([
          $css.compose($text.sm($text.medium)),
          $css.display("flex"),
          $css.flex_direction("column"),
          $css.align_items("start"),
          $css.gap(px(6)),
        ]),
      );
    },
  );
}

export function input_wrapper(
  state,
  icon_position,
  size,
  wrapper_style,
  attrs,
  children
) {
  return $sh.div(
    attrs,
    children,
    () => {
      return $css.class$(
        toList([
          $css.position("relative"),
          $css.width(percent(100)),
          $css.border_radius(px(8)),
          $css.border_width(px(1)),
          $css.border_style("solid"),
          $css.display("flex"),
          $css.background($colors.light.text_white),
          $css.padding_(
            (() => {
              if (size instanceof Xs) {
                return "4px 8px";
              } else if (size instanceof Small) {
                return "7px 10px";
              } else {
                return "9px 12px";
              }
            })(),
          ),
          $css.gap(
            (() => {
              if (size instanceof Xs) {
                return px(4);
              } else if (size instanceof Small) {
                return px(6);
              } else {
                return px(10);
              }
            })(),
          ),
          $css.align_items("center"),
          $css.flex_direction(
            (() => {
              if (icon_position instanceof $position.Right) {
                return "row-reverse";
              } else {
                return "row";
              }
            })(),
          ),
          $css.transition("box-shadow .2s, border-color .2s, color .2s"),
          $css.compose(
            (() => {
              if (state instanceof Standard) {
                return $css.class$(
                  toList([
                    $css.border_color($colors.light.grey_200),
                    $css.placeholder(
                      toList([$css.color($colors.light.grey_800)]),
                    ),
                    $css.focus_within(
                      toList([
                        $css.border("1px solid " + $colors.light.ai_400),
                        $css.outline("none"),
                        $css.box_shadow(
                          "0px 0px 0px 4px " + $colors.light.ai_100,
                        ),
                      ]),
                    ),
                  ]),
                );
              } else if (state instanceof Error) {
                return $css.class$(
                  toList([
                    $css.color($colors.light.error_800),
                    $css.border_color($colors.light.error_400),
                    $css.box_shadow(
                      "0px 0px 0px 4px " + $colors.light.error_100,
                    ),
                    $css.placeholder(
                      toList([$css.color($colors.light.error_600)]),
                    ),
                  ]),
                );
              } else {
                return $css.class$(
                  toList([
                    $css.border_color($colors.light.grey_200),
                    $css.placeholder(
                      toList([$css.color($colors.light.grey_600)]),
                    ),
                  ]),
                );
              }
            })(),
          ),
          (() => {
            if (wrapper_style instanceof Some) {
              let style = wrapper_style[0];
              return $css.compose(style);
            } else {
              return $css.none();
            }
          })(),
        ]),
      );
    },
  );
}

export function icon_display_wrapper(capture_events, attrs, children) {
  return $sh.div(
    attrs,
    children,
    () => {
      return $css.class$(
        toList([
          $css.display("flex"),
          $css.align_items("center"),
          $css.color($colors.light.grey_400),
          $bool_.choose(capture_events, $css.cursor("pointer"), $css.none()),
          $css.pointer_events(
            (() => {
              if (capture_events) {
                return "default";
              } else {
                return "none";
              }
            })(),
          ),
          $css.hover(toList([$css.color($colors.light.text_body)])),
        ]),
      );
    },
  );
}

export function icon_display(size, attrs, children) {
  let _block;
  if (size instanceof Xs) {
    _block = $icons.very_tiny;
  } else if (size instanceof Small) {
    _block = $icons.tiny;
  } else {
    _block = $icons.medium;
  }
  let icon_wrapper = _block;
  return $sh.div(
    attrs,
    toList([icon_wrapper(children)]),
    () => {
      return $css.class$(
        toList([
          $css.color($colors.light.grey_600),
          $css.transition("color .2s"),
          $css.hover(toList([$css.color($colors.light.text_body)])),
        ]),
      );
    },
  );
}

function input_base(size) {
  return $css.class$(
    toList([
      $css.compose(
        (() => {
          if (size instanceof Xs) {
            return $text.xs($text.regular);
          } else if (size instanceof Small) {
            return $text.sm($text.regular);
          } else {
            return $text.md($text.regular);
          }
        })(),
      ),
      $css.flex("1"),
      $css.min_width(px(0)),
      $css.display("block"),
      $css.appearance("none"),
      $css.color($colors.light.text_body),
      $css.border("none"),
      $css.border_radius(px(8)),
      $css.font_family("Roobert"),
      $css.outline("none"),
    ]),
  );
}

function custom_style(class$) {
  if (class$ instanceof Some) {
    let class$1 = class$[0];
    return $css.compose(class$1);
  } else {
    return $css.none();
  }
}

export function standard(size, class$, attrs) {
  return $sh.input(
    attrs,
    () => {
      return $css.class$(
        toList([$css.compose(input_base(size)), custom_style(class$)]),
      );
    },
  );
}

function resize_style(resize) {
  if (resize) {
    return $css.none();
  } else {
    return $css.resize("none");
  }
}

export function standard_multiline(size, class$, resize, attrs) {
  return $sh.textarea(
    attrs,
    toList([]),
    () => {
      return $css.class$(
        toList([
          $css.compose(input_base(size)),
          custom_style(class$),
          resize_style(resize),
        ]),
      );
    },
  );
}

export function disabled(size, class$, attrs) {
  return $sh.input(
    attrs,
    () => {
      return $css.class$(
        toList([
          $css.compose(input_base(size)),
          custom_style(class$),
          $css.disabled(
            toList([
              $css.color($colors.light.grey_600),
              $css.cursor("not-allowed"),
              $css.background_color($colors.light.transparent),
            ]),
          ),
        ]),
      );
    },
  );
}

export function disabled_multiline(size, class$, resize, attrs) {
  return $sh.textarea(
    attrs,
    toList([]),
    () => {
      return $css.class$(
        toList([
          $css.compose(input_base(size)),
          custom_style(class$),
          resize_style(resize),
          $css.disabled(
            toList([
              $css.color($colors.light.grey_600),
              $css.cursor("not-allowed"),
              $css.background_color($colors.light.transparent),
            ]),
          ),
        ]),
      );
    },
  );
}

export function error(size, class$, attrs) {
  return $sh.input(
    attrs,
    () => {
      return $css.class$(
        toList([$css.compose(input_base(size)), custom_style(class$)]),
      );
    },
  );
}

export function error_multiline(size, class$, resize, attrs) {
  return $sh.textarea(
    attrs,
    toList([]),
    () => {
      return $css.class$(
        toList([
          $css.compose(input_base(size)),
          custom_style(class$),
          resize_style(resize),
        ]),
      );
    },
  );
}

export function error_label(attrs, children) {
  return $sh.div(
    attrs,
    children,
    () => {
      return $css.class$(
        toList([
          $css.color($colors.light.error_800),
          $css.compose($text.sm($text.regular)),
        ]),
      );
    },
  );
}
